export default "__VITE_ASSET__ByTynjwi__"